import React, { useState } from "react";
import { useAppContext } from "../../context/appContext";

import {
  AdminEmails,
  AdminWorkDesc,
  AdminCustomSettings,
  AdminFeesDiscounts,
  AdminPriceTables,
  AdminUsers,
  AuditLog,
  VoipServices
} from "../../components/Admin";

function Admin() {
  const { isLoading } = useAppContext();
  const [menu, setMenu] = useState("email messages");
  const handleClick = (e) => {
    e.preventDefault();
    setMenu(e.target.name);
  };
  const buttons = [
    "user management",
    "price tables",
    "custom settings for current job",
    "fees/ Discounts/ Warranties",
    "default work descriptions",
    "default email messages",
    "recent database changes",
    "Messaging services"
  ];
  return (
    <div className="page admin">
      {/* ----- Admin ------ */}
      <div className="group whole">
        <form className="form">
          <h3>Admin Pages</h3>
          <div className="form-center">
            {buttons.map((title, index) => {
              return (
                <div className="one-third" key={index}>
                  <button
                    name={title}
                    className={
                      menu === title
                        ? "selected btn btn-block"
                        : "btn btn-block"
                    }
                    type="button"
                    onClick={handleClick}
                    disabled={isLoading}
                  >
                    {isLoading ? "please wait..." : title}
                  </button>
                </div>
              );
            })}
          </div>
        </form>
      </div>

      {menu === "user management" ? <AdminUsers /> : ""}      
      {menu === "price tables" ? <AdminPriceTables /> : ""}
      {menu === "custom settings for current job" ? <AdminCustomSettings /> : ""}
      {menu === "fees/ Discounts/ Warranties" ? <AdminFeesDiscounts /> : ""}
      {menu === "default work descriptions" ? <AdminWorkDesc /> : ""}
      {menu === "default email messages" ? <AdminEmails /> : ""}
      {menu === "recent database changes" ? <AuditLog /> : ""} 
      {menu === "Messaging services" ? <VoipServices /> : ""}
    </div>
  );
}
export default Admin;
